import { escapeHtml } from '../utils.js';

export function renderMostRead(items) {
  if (!Array.isArray(items)) return '';
  return items.map((item, index) => {
    const rank = item.rank || (index + 1);
    const views = item.views || (Math.floor(Math.random() * 2000) + 500); // Fallback visual
    return `
    <article class="trending-item">
      <span class="trending-item__rank">${rank}</span>
      <div class="trending-item__body">
        <h4 class="trending-item__title">${escapeHtml(item.title)}</h4>
        <span class="trending-item__views"><i class="fas fa-eye"></i> ${views} lecturas</span>
      </div>
    </article>
  `;
  }).join('');
}

export function renderTopics(topics) {
  if (!Array.isArray(topics)) return '';
  return topics.map(topic => {
    // Soporte para objetos o strings simples
    const tag = typeof topic === 'string' ? topic : topic.tag;
    const isHot = typeof topic === 'object' ? topic.hot : tag.includes('#'); // Heurística simple
    return `
      <a href="#" class="topic-chip ${isHot ? 'topic-chip--hot' : ''}">${escapeHtml(tag)}</a>
    `;
  }).join('');
}
